<template>
    <!-- Integration Card -->
    <div class="integrationCard d-flex flex-column border-light radius-10 shadow-10">
        <div class="logoHolder d-flex align-items-center justify-content-center radius-top-left-10 radius-top-right-10" :style="{'background-color':integration.color.main}">
            <!-- Warning -->
            <i v-if="warning().level >  0" v-tooltip="warning().message" class="warningSign fas fa-exclamation-triangle color-5" :class="{'color-6':warning().level == 2}"></i>

            <i v-if="showSettingsCog(integration)" class="settingsIcon fas fa-cog lightest opacity-50 pointer" @click="openIntegrationSettings(integration)"></i>
                
            <img v-if="integration.logo" class="logo" :src="integration.logo.white" alt="">
            <div v-else class="fs-large lightest bold">
                {{integration.label}}
            </div>

            <!-- Status -->
            <span 
                v-if="showStatus(integration)" 
                class="status px-2 py-0 radius-normal fs-smaller bold" 
                :class="['bg-'+status(integration.integrationStatus).backgroundColor, status(integration.integrationStatus).textColor]"
            >
                {{status(integration.integrationStatus).label}}
            </span>
        </div>

        <div class="p-2 d-flex flex-column flex-grow-1">
            <div class="fs-small descriptionHolder flex-grow-1 my-1">
                {{integration.descriptionSmall}}
            </div>

            <div class="mt-2">
                <!-- Loading  -->
                <div v-if="getIsLoadingSupplierIntegrations" class="text-center">
                    <loader></loader>
                </div>

                <!-- Coming Soon -->
                <button v-else-if="integration.comingSoon && integration.comingSoon == true" type="button" class="btn blue w-100" @click="openIntegration(integration)">Details</button>

                <!-- Connect -->
                <button v-else-if="(integration.integrationStatus == 0 || integration.integrationStatus == 4) && !integration.showView" type="button" class="btn green w-100" @click="openIntegration(integration)">Connect</button>
                
                <!-- View -->
                <button v-else type="button" class="btn tertiary w-100" @click="openIntegration(integration)">View</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import loader from '@/tools/loaders/loader1'

export default {
    props: {
        integration: {
            required: true,
            type: Object
        }
    },
    computed: {
        ...mapGetters([
            'getIsLoadingSupplierIntegrations',
            'getIntegrationStatus'
        ]),
    },
    methods: {
        ...mapActions([
            'startIntegration',
            'openIntegrationSettings',
            'setIntegration'
        ]),
        showStatus(integration) {
            return integration.showStatus !== false;
        },
        showSettingsCog(integration) {
            return integration.integrationStatus == 1 && integration.showSettings;
        },
        status(statusId) {
            if (this.integration.comingSoon ){
                return this.getIntegrationStatus(-1);
            } else {
                return this.getIntegrationStatus(statusId);
            }
        },
        warning() {
            return {
                level: this.integration.integrationStatusInfo? this.integration.integrationStatusInfo : 0,
                message: this.integration.integrationStatusInfoMessage? this.integration.integrationStatusInfoMessage : null
            }
        },
        openIntegration(integration) {
            this.setIntegration(integration);
            this.startIntegration(integration);
        }
    },
    components: {
        loader
    }
}
</script>

<style lang="scss" scoped>
    .integrationCard {
        width: 191px;

        .logoHolder {
            height: 110px;
            width: 100%;
            position: relative;

            .warningSign {
                position: absolute;
                bottom: -8px;
                right: -4px;
                background-color: #FFF;
                padding: 2px;
                border-radius: 6px;
            }

            .settingsIcon {
                position: absolute;
                right: 0;
                top: 5px;
            }

            .logo {
                max-width: 143px;
                max-height: 75px;
                transition: all ease-in-out 300ms;
            }

            .status {
                position: absolute;
                bottom: -9px;
                left: 7px;
                border: 1px solid #FFF;
            }
        }

        .descriptionHolder {
            -webkit-line-clamp: 5;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>



// WEBPACK FOOTER //
// IntegrationCard.vue?576a32de